import * as Yup from 'yup';

export const codeValidationSchema = Yup.object({
  code: Yup.string().length(6, 'Code must be 6 digits').required('Code is required'),
});
